import { useEffect } from "react";
import {
    POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID,
    RP_WEBHOOK_CUSTOM_HEADER_PROPERTY_TYPE_ID
} from "@constants/webhook-constants";
import { PageLevelTypes } from "@enums/page-level-types";
import { GeneralAdvancedValidationErrors } from "@idw-types/common/validation/common/general-advanced-validation-errors";
import { AxnDocumentationLink } from "@idw-types/data/reference-data/axn/axn-documentation-link";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { WebhookConfigurationContainer } from "@containers/common/properties-sections/webhook-configuration-container/webhook-configuration-container";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { SecureWebhookTypes } from "@enums/secure-webhook-types";

type VerificationServiceWebhookConfigurationContainerProps = {
    isDisabled: boolean;
    validationErrors: GeneralAdvancedValidationErrors;
    apiKey: string;
    documentationLinks: Array<AxnDocumentationLink>;
    rpServiceConfiguration: FormattedRpServiceConfiguration;
    updateProperties: (properties: Array<{
        propertyTypeId: string;
        newValue: string;
        added: boolean;
    }>) => void;
};

export const VerificationServiceWebhookConfigurationContainer = (props: VerificationServiceWebhookConfigurationContainerProps) => {
    const {
        isDisabled,
        validationErrors,
        apiKey,
        documentationLinks,
        rpServiceConfiguration,
        updateProperties
    } = props;

    useEffect(() => {

    }, [rpServiceConfiguration.appliedProfiles]);

    const onChangeEnableWebhook = (newValue: string) => {
        if (isStringTrue(newValue)) {
            updateProperties([
                { propertyTypeId: POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: "true", added: true },
                { propertyTypeId: RP_WEBHOOK_URL_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID, newValue: apiKey, added: true }
            ]);
        } else {
            updateProperties([
                { propertyTypeId: POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_URL_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID, newValue: null, added: false },
            ]);
        }
    };

    const onChangeIncludeUserData = (newValue: string) => {
        if (isStringTrue(newValue)) {
            updateProperties([{ propertyTypeId: POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: "true", added: true }]);
        } else if (rpServiceConfiguration.workflowID) {
            updateProperties([{ propertyTypeId: POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: "false", added: true }]);
        } else {
            updateProperties([{ propertyTypeId: POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID, newValue: null, added: false }]);
        }
    };

    const onChangeAddWebhookWrapperObject = (newValue: string) => {
        if (isStringTrue(newValue)) {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID, newValue: "", added: true }]);
        } else if (rpServiceConfiguration.workflowID) {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID, newValue: null, added: true }]);
        } else {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID, newValue: null, added: false }]);
        }
    };

    const onChangeSetToFlatEndpoint = (newValue: string) => {
        if (isStringTrue(newValue)) {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID, newValue: "true", added: true }]);
        } else if (rpServiceConfiguration.workflowID) {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID, newValue: "false", added: true }]);
        } else {
            updateProperties([{ propertyTypeId: RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID, newValue: null, added: false }]);
        }
    };

    const onChangeSecurityTypeWebhookEnabled = (newValue: SelectOption) => {
        if (newValue.value === SecureWebhookTypes.NONE) {
            updateProperties([
                { propertyTypeId: RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_CUSTOM_HEADER_PROPERTY_TYPE_ID, newValue: null, added: false },

            ]);
        }
        if (newValue.value === SecureWebhookTypes.BASIC) {
            updateProperties([
                { propertyTypeId: RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID, newValue: newValue.value, added: true },
                { propertyTypeId: RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_CUSTOM_HEADER_PROPERTY_TYPE_ID, newValue: null, added: false },

            ]);
        }
        else if (newValue.value === SecureWebhookTypes.OAUTH) {
            updateProperties([
                { propertyTypeId: RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID, newValue: newValue.value, added: true },
                { propertyTypeId: RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_CUSTOM_HEADER_PROPERTY_TYPE_ID, newValue: null, added: false },

            ]);
        }
        else if (newValue.value === SecureWebhookTypes.CUSTOM_HEADER) {
            updateProperties([
                { propertyTypeId: RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID, newValue: newValue.value, added: true },
                { propertyTypeId: RP_WEBHOOK_CUSTOM_HEADER_PROPERTY_TYPE_ID, newValue: "", added: true },
                { propertyTypeId: RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID, newValue: null, added: false },
                { propertyTypeId: RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID, newValue: null, added: false },
            ]);
        }
    };

    return (
        <WebhookConfigurationContainer
            isDisabled={isDisabled}
            validationErrors={validationErrors}
            documentationLinks={documentationLinks}
            appliedProfiles={rpServiceConfiguration.appliedProfiles}
            properties={rpServiceConfiguration.properties}
            pageLevel={PageLevelTypes.APIKEY}
            workflowId={rpServiceConfiguration.workflowID}
            canModifyNonRestrictedProperties={rpServiceConfiguration.permissions.canModifyNonRestrictedProperties}
            updateProperties={updateProperties}
            onChangeAddWebhookWrapperObject={onChangeAddWebhookWrapperObject}
            onChangeEnableWebhook={onChangeEnableWebhook}
            onChangeIncludeUserData={onChangeIncludeUserData}
            onChangeSecurityTypeWebhookEnabled={onChangeSecurityTypeWebhookEnabled}
            onChangeSetToFlatEndpoint={onChangeSetToFlatEndpoint}
        />
    );
};